export const FAILED_TO_FETCH_MESSAGE_RAW = 'Failed to fetch';
export const FAILED_TO_FETCH_MESSAGE_PRETTY =
  "Could not connect to an API. If you're running the app locally, did you start the local API by running `yarn start:api` in a new terminal window?";
export const MISSING_APP_INSTANCE_ID_MESSAGE =
  'Missing app instance ID. Use a sample app instance to test out connecting to the Graasp API.';
export const MISSING_SPACE_ID_MESSAGE =
  'Missing space ID. Use a sample space to test out connecting to the Graasp API.';
export const MISSING_API_HOST_MESSAGE = 'Missing API host.';
export const UNEXPECTED_ERROR_MESSAGE = 'An unexpected error has occurred.';
export const MISSING_APP_INSTANCE_RESOURCE_ID_MESSAGE =
  'No app instance resource id specified.';
